<div (click)="onClick()">
	<img src="assets/img/clever-inc-logo-vector-c-only.svg" width="25" height="25" />
	<span>Log in with Clever</span>
</div>
